import React from 'react'
import { Box, useTheme } from '@mui/material'

import { LinkAnimation } from './LinkAnimation'

type AnnouncementProps = {
  data: {
    announcebannerbuttons: {
      _key: string
      btntext: string
      btnlink: string
    }[]
  }
}

export const Announcement = ({ data }: AnnouncementProps) => {
  const { palette } = useTheme()

  return (
    <Box
      sx={{
        alignItems: 'center',
        background: `linear-gradient(92.95deg, ${palette.primary.main} 0.98%, ${palette.info.main} 104.4%)`,
        display: 'flex',
        justifyContent: 'center',
        py: { xs: 4, mobile: 3 }
      }}
    >
      {data.announcebannerbuttons.map(item => (
        <LinkAnimation
          key={item._key}
          link={item.btnlink}
          text={item.btntext}
        />
      ))}
    </Box>
  )
}
